
import { defineComponent, PropType } from "vue";
import type { CourseType } from "@/types/CourseType";

export default defineComponent({
  name: "course-card",
  props: {
    course: {
      type: Object as PropType<CourseType>,
      required: true
    },
    currentLanguage: {
      type: String,
      required: true
    }
  }
});
